export default __webpack_public_path__ + "static/media/youtubeDeskMobile.d80dba13.svg";